import React from 'react';
import { SOCIAL_LINKS } from '../../utils/constants';
import SocialIcon from '../../assets/icons/SocialIcons';

export default function SocialLinks({ size = 36 }) {
  return (
    <div style={{ display: 'flex', gap: 9 }}>
      {SOCIAL_LINKS.map((s) => (
        <a key={s.platform} href={s.url} target="_blank" rel="noopener noreferrer"
          className="social-link" style={{ width: size, height: size }}
          aria-label={`Follow us on ${s.platform}`}>
          <SocialIcon name={s.icon} size={Math.round(size * 0.44)} />
        </a>
      ))}
    </div>
  );
}
